<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_DOCUMENTS')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_DOCUMENTS')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">

    <h4>Links</h4>

    <form [formGroup]="form">
        <table class="table table-striped table-sm mb-0" *ngIf="getLengthOfFormArray('links') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th>Name</th>
                <th>URL</th>
            </tr>
            </thead>
            <tbody formArrayName="links">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'links').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times"></i></button>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="name"
                               *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.name }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="url"
                               *ngIf="viewMode !== ViewMode.VIEW" placeholder="https://www.orf.at">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">
                            <a [href]="entry.value.url" target="_blank">{{ entry.value.url }}</a>
                        </ng-container>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3" (click)="addFormItem({}, 'links')">
                <i class="fas fa-plus"></i> Link hinzufügen
            </button>
        </div>

        <p class="text-muted" *ngIf="getLengthOfFormArray('links') === 0">Keine Links hinzugefügt</p>
    </form>

    <h4>Dokumente</h4>

    <div class="table-responsive">
        <table class="table table-sm table-hover table-files">
            <thead>
            <tr>
                <th style="width: 85px"></th>
                <th style="width: 120px">Vorschau</th>
                <th>Typ</th>
                <th>Name</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let file of files">
                <td>
                    <button type="button" class="btn btn-danger btn-sm" *ngIf="viewMode !== ViewMode.VIEW" (click)="deleteOrRemoveFile(file)">
                        <i class="fa-solid fa-trash"></i>
                    </button>
                    <button type="button" class="btn btn-success btn-sm ms-2" (click)="getFileData(file)">
                        <i class="fa-solid fa-download"></i>
                    </button>
                </td>
                <td>
                    <ng-container *ngIf="file.type.startsWith('image')">
                        <img class="img-fluid" *ngIf="file.thumbnail" [src]="'data:' + file.type + ';base64,' + file.thumbnail">
                        <img class="img-fluid" *ngIf="file.data" [src]="file.data">
                    </ng-container>
                    <ng-container *ngIf="!file.type.startsWith('image')">
                        Nicht verfügbar
                    </ng-container>
                </td>
                <td>
                    {{ file.type | filetype }}
                </td>
                <td>
                    {{ file.name }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>

    <div [hidden]="viewMode === ViewMode.VIEW">
        <button type="button" class="btn btn-secondary btn-sm mb-3" (click)="triggerFileInput()">Foto oder Datei hochladen</button>
        <input type="file" #fileInput class="d-none" multiple (change)="handleInputChange($event)">
    </div>

    <p class="text-muted" *ngIf="files.length === 0">Keine Anhänge vorhanden</p>
</div>
